export default "__VITE_ASSET__B6llOu3w__"